import request from '@/utils/request';
const agencyUrl = "https://cumulus.jidianyun.net/agency"
const permissionUrl = "https://cumulus.jidianyun.net/sys"


//获取sign
export const getSign = (params,config = {}) =>
    request.post('/wxApp/php/public/motorhouse/getSign',params,{...config});

//发送验证码
export const getCode = (params,config = {}) =>
    request.post('/wxApp/php/public/motorhouse/sendcode',params,{...config});



    //企业注册
export const addOrEditAgency = (params,config = {}) =>
request.post(`${agencyUrl}/agency/modify`,params,{...config});

/** 获取行业列表 */
export const getIndustryList = (params, config = {}) =>
request.post(`${agencyUrl}/industry/pageIndustry`, params, { ...config });


// 上传图片
export const uploadImg = (params, config = {}) =>
  request.post(`${permissionUrl}/file/uploadImg`, params, {
    ...config,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  
 // 获取省市区
//code
//level 1-省，2-市，3-区
export const queryCity = (params, config = {}) =>
request.post(`${permissionUrl}/city/queryCity`, params, { ...config });


// 登录
export const login = (params, config = {}) =>
  request.post(`${permissionUrl}/admin/adminLogin`, params, { ...config });

// 获取用户基本资料
export const queryDetailById = (params, config = {}) =>
  request.post(`${permissionUrl}/admin/queryDetailById`, params, { ...config });